import { Step } from "react-joyride";

export const tourStepsMyAccount = (): Step[] => {
  const steps: Step[] = [
    {
      target: ".my-account",
      content:
        "My Account shows your profile. You can change the name students see and choose Teacher or Student.",
      disableBeacon: true,
    },
    {
      target: ".user-profile",
      content:
        "This is the name and photo from your login. The display name is what appears in games and reports.",
    },
    {
      target: ".update-display-name-form",
      content:
        "Update your display name here if you want something other than your login name.",
    },
    {
      target: ".role-selection",
      content:
        "Teacher is for creating and managing collections. Student is for practicing. Pick the one that matches how you use the site.",
    },
    {
      target: ".role-features",
      content:
        "This list shows what your role can do, such as creating collections or running practice sessions.",
    },
  ];

  return steps;
};
